import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '../lib/cn';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  invalid?: boolean;
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, invalid, ...rest }, ref) => (
    <textarea
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'block w-full min-h-[96px] p-3 bg-surface border border-border rounded-md text-[15px] text-fg outline-none transition-[border-color,box-shadow] placeholder:text-fg-faint focus-visible:border-fg focus-visible:ring-2 focus-visible:ring-fg/10 disabled:cursor-not-allowed disabled:opacity-60',
        invalid && 'border-brand focus-visible:border-brand focus-visible:ring-brand/20',
        className,
      )}
      {...rest}
    />
  ),
);
Textarea.displayName = 'Textarea';
